import React from 'react';
import { action, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import { ImgClose } from './Images/ImgClose.tsx';

type ToastType = 'info' | 'success' | 'warning' | 'error';

type ToastItem = {
  id: number;
  type: ToastType;
  message: string;
  title?: string;
};

class ToastService {
  @observable private _toasts: ToastItem[] = [];
  private _nextId = 1;

  constructor() {
    makeObservable(this);
  }

  get toasts() {
    return this._toasts;
  }

  @action
  private _add(type: ToastType, message: string, title?: string, timeoutMs = 9000) {
    const id = this._nextId++;
    this._toasts.push({ id, type, message, title });
    window.setTimeout(() => this.remove(id), timeoutMs);
  }

  info(message: string, title?: string) {
    this._add('info', message, title);
  }

  success(message: string, title?: string) {
    this._add('success', message, title);
  }

  warning(message: string, title?: string) {
    this._add('warning', message, title);
  }

  error(message: string, title?: string) {
    this._add('error', message, title, 12000);
  }

  @action
  remove(id: number) {
    this._toasts = this._toasts.filter(t => t.id !== id);
  }
}

@observer
export class Toasts extends React.Component {
  render() {
    return (
      <div className="toast-container" role="status" aria-live="polite">
        {toastService.toasts.map(toast => (
          <div key={toast.id} className={`toast toast-${toast.type}`}>
            <div className="toast-header">
              <strong>{toast.title || toast.type.toUpperCase()}</strong>
              <button className="toast-close" onClick={() => toastService.remove(toast.id)} aria-label="Close toast"><ImgClose /></button>
            </div>
            <pre className="toast-message">{toast.message}</pre>
          </div>
        ))}
      </div>
    );
  }
}

export const toastService = new ToastService();